import httpClient from "./httpClient";
import { HealthService } from "../types/healthservice";
import { Group } from "../types/groups";
import { User } from "../types/users";

const END_POINT = "/healthservices";

const getHealthServices = async (): Promise<HealthService[] | undefined> => {
	const response = await httpClient.get(END_POINT);
	return response.data as HealthService[];
};

const getHealthService = async (
	id: number
): Promise<HealthService | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}`);
	return response.data as HealthService;
};

const getGroups = async (id: number): Promise<Group[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/groups`);
	return response.data as Group[];
};

const getUsers = async (id: number): Promise<User[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/users`);
	return response.data as User[];
};

const remove = async (id: number) => {
	const response = await httpClient.delete(`${END_POINT}/${id}`);
	return response.data;
};

const update = async (
	healthservice: HealthService
): Promise<HealthService | undefined> => {
	const { id } = healthservice;
	const response = await httpClient.put(`${END_POINT}/${id}`, healthservice);
	return response.data as HealthService;
};

const create = async (
	healthservice: HealthService
): Promise<HealthService | undefined> => {
	const response = await httpClient.post(`${END_POINT}`, healthservice);
	return response.data as HealthService;
};

export {
	getHealthServices,
	getHealthService,
	getGroups,
	getUsers,
	remove,
	update,
	create
};
